import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_ERROR_ILLUSTRATION = 'errors/general';
const DEFAULT_ERROR_HEADER = 'fatalErrors.errors.header';
const DEFAULT_ERROR_MESSAGE = 'fatalErrors.errors.message';
const StyledDiv = styled.div.withConfig({
  displayName: "ErrorMessage__StyledDiv",
  componentId: "dd6gk-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    textAlign: 'center',
    marginBlock: theme.space['400']
  };
});
const ErrorMessage = ({
  message,
  children
}) => {
  return /*#__PURE__*/_jsxs(StyledDiv, {
    children: [/*#__PURE__*/_jsx(Illustration, {
      width: 200,
      name: DEFAULT_ERROR_ILLUSTRATION,
      marginBlockEnd: "400"
    }), /*#__PURE__*/_jsxs(View, {
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: DEFAULT_ERROR_HEADER
        })
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: message || DEFAULT_ERROR_MESSAGE
      })]
    }), children]
  });
};
export default ErrorMessage;